import request from "../utils/request";

export const getCoverings = '/covering/'

export function updateCoveringFromPink() {
    return request.request({
        url: '/covering/update',
        method: 'post'
    })
}

export function importCoverings(file: File){
    const formData = new FormData()
    formData.append('file', file)
    return request.request({
        url: '/covering/import',
        method: 'post',
        data: formData
    })
}
